import React, { useState } from 'react';
import Modal from '../common/Modal';

export default function CreateFolderModal({ isOpen, onClose, onSubmit }) {
  const [folderName, setFolderName] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const trimmed = folderName.trim();
    if (!trimmed) {
      setError('Folder name is required');
      return;
    }
    if (trimmed.includes('..') || trimmed.includes('/') || trimmed.includes('\\')) {
      setError('Invalid folder name');
      return;
    }
    if (trimmed.length > 100) {
      setError('Folder name must be 100 characters or less');
      return;
    }
    const allowed = /^[a-zA-Z0-9 \-_().]+$/;
    if (!allowed.test(trimmed)) {
      setError('Folder name contains invalid characters');
      return;
    }

    setSubmitting(true);
    try {
      await onSubmit(trimmed);
      setFolderName('');
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to create folder');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Create Folder">
      <form onSubmit={handleSubmit}>
        <div className="mol-form-group">
          <label className="mol-label">Folder Name</label>
          <input
            className="mol-input"
            type="text"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            placeholder="e.g. new-event-folder"
            maxLength={100}
            autoFocus
          />
          {error && <p className="mol-form-error">{error}</p>}
        </div>
        <div className="mol-modal__actions">
          <button type="button" className="mol-btn mol-btn--secondary" onClick={onClose}>Cancel</button>
          <button type="submit" className="mol-btn mol-btn--primary" disabled={submitting}>
            {submitting ? 'Creating...' : 'Create Folder'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
